import React from 'react';

const StatusBadge = ({ status, active }) => {
  const isActive =
    typeof active === 'boolean'
      ? active
      : String(status || '').toUpperCase() === 'ACTIVE';

  return (
    <span
      className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${
        isActive
          ? 'bg-green-50 text-green-700'
          : 'bg-gray-100 text-gray-600'
      }`}
    >
      {isActive ? 'Active' : 'Inactive'}
    </span>
  );
};

export default StatusBadge;
